import { lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { NEXT_URL_PATH, SERVICES_PATH } from "../common/env";
import ABACRoute from "../components/ABACRoute";
import { ProductCollectionRetriever } from "../components/admin/ProductCollectionRetriever";
import { MixpanelInitialize } from "../components/mixpanel-initialize/mixpanel-initialize";
import { InterceptNextURL } from "../components/NextUrl/InterceptNextURL";
import { StoreServiceIdFromLocationSlugIntoNextUrl } from "../components/NextUrl/StoreServiceIdFromLocationSlugIntoNextUrl";
import { DialogHandler } from "../components/poppers/DialogHandler";
import QuestionnaireLoading from "../components/QuestionnaireLoading";
import SEO from "../components/Seo";
import SuspenseWrapper from "../components/SuspenseWrapper";

const AdminRoutes = lazy(() => import(/* webpackChunkName: 'back-office' */ "./AdminRoutes"));
const CitizenRoutes = lazy(() => import(/* webpackChunkName: 'customer' */ "./CitizenRoutes"));

export function CitizenAdminSwitch(): JSX.Element {
  return (
    <Router>
      <Switch>
        <ABACRoute allowedIf={{ can: "readAll", model: "Admin" }} redirectTo="/ssi-login" path="/admin">
          <SEO title="Admin" />
          <SuspenseWrapper>
            <ProductCollectionRetriever />
            <AdminRoutes />
          </SuspenseWrapper>
        </ABACRoute>
        <Route path="/">
          <MixpanelInitialize />
          <InterceptNextURL />
          <DialogHandler />
          <Route path={`${NEXT_URL_PATH}${SERVICES_PATH}/:id`}>
            <StoreServiceIdFromLocationSlugIntoNextUrl />
          </Route>
          <SEO title="Scopri e richiedi i BonusX te | I tuoi bonus. Il tuo tempo. I tuoi diritti." />
          <SuspenseWrapper>
            <CitizenRoutes />
            <QuestionnaireLoading />
          </SuspenseWrapper>
        </Route>
      </Switch>
    </Router>
  );
}
